import { ElementProps } from '@/components/sections/builder/types';
import {
  ImageWithTextElementDataType,
  ImageWithTextTitleElementDataType,
} from '@/components/sections/builder/elements/body/image-with-text/types';
import InputTab from '@/components/sections/builder/settings/input-tab';
import { useBuilderStore } from '@/stores/builder';
import clsx from 'clsx';
import { shallow } from 'zustand/shallow';
import { Type } from 'lucide-react';
import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';

const defaultData: ImageWithTextTitleElementDataType = {
  name: 'Title',
  label: 'Image with text',
  headingSize: 'small',
  padding: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as ImageWithTextTitleElementDataType;

  const parentData = element.parentData as ImageWithTextElementDataType;

  const modifiedLabel = data.label.replace(
    /<strong>(.*?)<\/strong>/g,
    '<span class="font-semibold">$1</span>'
  );
  return (
    <>
      <h1
        className={clsx(
          'duration-50 w-full',
          `hero-title-padding `,
          data.headingSize === 'large' && 'text-3xl @sm:text-3xl md:text-5xl lg:text-5xl',
          data.headingSize === 'medium' && 'text-2xl @sm:text-4xl md:text-4xl lg:text-4xl',
          data.headingSize === 'small' && 'text-2xl @sm:text-2xl md:text-2xl lg:text-3xl'
        )}
        data-animation='true'
        dangerouslySetInnerHTML={{ __html: modifiedLabel }}
      />
      <style jsx>
        {`
          @media (min-width: 1024px) {
            .hero-title-padding {
              padding-top: ${data.padding?.top || 0}px;
              padding-bottom: ${data.padding?.bottom || 0}px;
              padding-left: ${data.padding?.left || 0}px;
              padding-right: ${data.padding?.right || 0}px;
            }
          }

          .text_color_container {
            color: ${parentData.sectionColorScheme?.text || '#6b7280'};
          }
        `}
      </style>
    </>
  );
};

export const ElementPreviewIcon = Type;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as ImageWithTextTitleElementDataType;

  return (
    <div>
      <div className='mb-4 font-bold'>Text</div>
      <TextEditorMinimal
        value={data.label}
        onChange={(val) =>
          builder.setChildData(element.parentId as string, element.id, {
            label: val,
          })
        }
        output='html'
        className='mb-2 w-full '
        editorProps={{
          attributes: {
            class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
          },
        }}
        editable
      />
      <div className='mb-4 mt-4 font-bold'>Heading Size</div>
      <InputTab
        defaultValue={data.headingSize}
        options={[
          { label: 'Small', value: 'small' },
          { label: 'Medium', value: 'medium' },
          { label: 'Large', value: 'large' },
        ]}
        onChange={(v) =>
          builder.setChildData(element.parentId as string, element.id, {
            headingSize: v,
          })
        }
      />
    </div>
  );
}

const ImageWithTextTitle = {
  type: 'image_with_text_title',
  group: 'image_with_text',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default ImageWithTextTitle;
